import { Time } from "@angular/common";

export interface IExam {
    id: number;
    examinationName: string;
    session: string;
    duration: number;
    questionSelectionMode: string;
    numberofQuestionsPerCategory: number;
    requireProctorStart: boolean;
    examinationType: string;
    examinationTypeenum: string;
    showScoreWhenFinished: boolean;
    numberOfQuestions: number;
    examStartDate: Date;
    examEndDate: Date;
    adminStartTime: Date;
    selfRegistrationEndDate: Date;
    selfSchedule: boolean;
    selfRescheduleAfter: boolean;
    requireAdminStart: boolean;
    enforceScheduleEndTime: boolean;
    showSubmitButtonOnEveryQuestion: boolean;
    externalExaminationID: string;
    subject: string;
    instructionsHTML: string;
    postExamMessages: string;
    emailNotificationTemplate: string;
    randomiseOptions: boolean;
    practiceExam: boolean;
    calculatorType: string;
    examPaused: boolean;
    detectFocusLoss: boolean;
    permissibleDurationOfLoss: number;
    noOfTimesAllowedForFocusLoss: number;
    lossOfFocusAction: string;
    lossofFocusReduceTimeActionDuration: number;
    lossofFocusRestartActionLimit: number;
    passportMandatory: boolean;
    skipAIPassportCheck: boolean;
    useSEB: boolean;
    useCaptcha: boolean;
    liteMode: boolean;
    allowComplaint: boolean;
    allowExamRetake: boolean;
    maxRetake: number;
    answeredQuestionsPercentage: number;
    examinationDurationPercentage: number;
    excludeFromRDSConfigCalculation: boolean;
    sectionalizedEssayMarking: boolean;
    proctorAccessCodes: string;
    maximumNumberOfEssayAnswers: number;
    maximumNumberOfSAQAnswers: number;
    examinationGroupID: string;
    mockExam: boolean;
    showQuestionList: boolean;
    useQuestionBank: boolean;
    allowExternalPrimaryWebcam: boolean;
    allowExternalSecondViewWebcam: boolean;
    examQuestionBanks?: IExamQuestionBank[];
    scheduleFile: File;
    notifyCandidatesByEmail: boolean;
    requireSecondView: boolean;
    noPrimaryStreamPolicy: string;
    noSecondViewStreamPolicy: string;
    questionFormat: string;
    questionFile: File;
    emailMessage: string;
    useRawHTML: boolean;
    psychometricTest: boolean;
    recording: boolean;
    facialRecognition: boolean;
    aIProctoring: boolean;
    liveProctoring: boolean;
}

export interface IExamQuestionBank {
    questionBankID: number;
    totalNumberOfQuestions: number;
    questionBankPoolSize: number;
    isWebTestBank: boolean;
    name: string;
    category: string;
    numberOfQuestions: number;
    examinationID: number;
    questionBankSource: string;
    disabled: boolean;
    isPsychometricTestBank: boolean;
    id: number;
}

export interface IQuestionBankDto {
    questionBankID: number;
    numberOfQuestions: number;
    questionBankPoolSize: number;
    isWebTestBank: boolean;
    selected?: boolean;
    name: string;
    totalNumberOfQuestions: number;
    category: string;
}

export interface IUploadQuestion {
    id: number;
    file: File;
    questionFormat: string;
    encoding: string;
    category: string;
    isNegativeMark: boolean;
    isHtml: boolean;
}

export interface IDailyProctorScheduleModel {
    examinationID: number;
    utcDailyStartTime: Time;
    utcDailyEndTime: Date;
    excludeWeekends: boolean;
    maxCandidateNoPerDay: number;
}

export interface IFileDownload {
    fileName: string;
    size: number;
    extension: string;
    file: Blob;
}

export interface IExamQuestions {
    examinationQuestionID: number;
    examinationID: number;
    questionNumber: number;
    questionType: string;
    language: string;
    languageEnum: string;
    questionHtml: string;
    category: string;
    marks: number;
    maxWordCount: number;
    penaltyMarks: number;
    disabled: boolean;
    compulsory: boolean;
    options: IExamQuestionOptions[];
    saqPossibleAnsers: string;
    saqAnswersList?: ICheckboxItem[];
    essaySubQuestions: IExamQuestionEssaySubQuestion[];
    questionID?: number;
    questionSource?: string;
    questionBankQuestionID?: number;
    questionGroupID?: string;
}

export interface IExamQuestionEssaySubQuestion {
    examinationQuestionID: number;
    essaySubQuestionID: number;
    questionHtml: string;
    questionNoLabel: string;
    marks: number;
}

export interface IExamQuestionOptions {
    examinationQuestionID: number;
    optionID: number;
    optionHtml: string;
    answer: boolean;
}

export interface ICheckboxItem {
    value: string;
    isChecked: boolean;
}

export interface IResultReport {
    examinationID: number;
    writtenOnly: boolean;
    dateOfWriting: string;
    sortBy: string;
    includePassportPhoto: boolean;
    includeContactDetails: boolean;
    candidateNoList: string;
    cutOffScore: number;
    cutOffPercentage: number;
    skipImportCandidateData: boolean;
    faceMismatchFlagsThreshold:number;
    multipleFacesFlagsThreshold:number;
    noFaceFlagsThreshold:number;
    noiseFlagsThreshold:number;
    humanFlagsThreshold:number;
    includeMalpracticeSuspicion:boolean;
    highScorePercentile:number;
    highScorePercentage:number;
}

export interface ICandidate {
    candidateId: number;
    examNo: string;
    lastName: string;
    firstName: string;
    otherNames: string;
    mobileNo: string;
    emailAddress: string;
    gender: string;
    requiresScreenReader: boolean;
    extraField1: string;
    extraField2: string;
    extraField3: string;
    skipAIFaceMatching: boolean;
    unlockPassportPhoto: boolean;

}

export interface IPassport {
    examNo: string;
    file: File;
    imageUrl: string;
}

export interface IScheduleCandidate {
    examinationID: number;
    examNo: string;
    status: string;
    additionalMinutes: number;
    score: number;
    attempt: number;
    startDate: Date;
    endDate: Date;
    randomiseVenues: boolean;
    notifyCandidatesByEmail: boolean;
    gapPerBatch: number;
    capacityPerSlot: number;
}

export interface IBuyUnits {
    units: number;
    price: number;
    pricePerUnit: number;
}

export interface IImportExamCandidate {
    examinationID: number;
    notifyCandidatesByEmail: boolean;
    gapPerBatch: number;
    capacityPerSlot: number;
    batchStartDateTime: Date;
    batchEndDateTime: Date;
    candidateList: string;
    file: File;
}

export interface IExamCategory {
    id: number;
    examinationID: number;
    numberOfQuestions: number;
    category: string;
    instruction: string;
    maximumNumberOfEssayAnswers: number;
    maximumNumberOfSAQAnswers: number;
    questionBankPoolSize?: number;
    categorySource?: string;
    examQuestionBankID?: number
}

export interface IDashExam {
    examinationName: string;
    duration: number;
    scheduledCount: number;
    examStartDate: Date;
    examEndDate: Date;
    id: number;
}

export interface IDasboard {
    examCount: number;
    writtenCount: number;
    ongoingCount: number;
    pendingCount: number;
    candidateCount: number;
    todaysExamination: IDashExam[];
    upcomingExaminations: IDashExam[];
    concludedExaminations: IDashExam[];
}

export interface IExamPenalty {
    id: number,
    detectFocusLoss: boolean,
    permissibleDurationOfLoss: number,
    maxAllowedFocusLossCount: number,
    focusLossAction: string,
    focussLossTimePenalty: number,
    focussLossRestartActionLimit: number,
    // concurrentLoginPenalty: string,
}

export interface IClientAcount {
    companyID: string;
    companyName: string;
    companyEmail: string;
    companyPhoneNo: string;
    companyCertificate: File;
    CompanyCertificateByte: Blob;
    extension: string;
    companyRegistrationNo: string;
    contactPersonName: string;
    contactPersonEmail: string;
    contactPersonPhoneNo: string;
    password: string;
    companyWebsite: string;
}

export type GenerateSEBConfigModel = {
    id: number,
    prohibitedProcesses: string,
    permittedProcesses: string,
    maxNoOfDisplays: number;
};

export interface Complaint {
    complaintID: string;
    examNo: string;
    examinationID: number;
    examinationScheduleID: number;
    attempt: number;
    categoryID: string;
    status: string;
    closedDate: Date;
    submittedDate: Date;
}
export class ComplaintDetails {
    complaintID: string = "";
    scheduleStatus: string = "";
    scheduleId: number = 0;
    examId: number = 0;
    examNo: string = "";
    response: string = "";
    scheduleStartDateTime: Date;
    status: string = "";
    complaintCategory: string = "";
    submittedDate: Date;
    closedDate: Date;
    examDetail: IExam;
    complaintHelpText: any = {};
    responses: ComplaintResponse[] = [];
}
export class ComplaintResponse {
    complaintID: string = "";
    response: string = "";
    isAdminResponse: boolean;
    responseDate: Date;
    sentBy: string = "";
}
export interface SendEmailMessage {
    message: string;
    emailSubject: string;
    examNoList: string[];
    sendLoginLink: boolean;
    sendSEBLink: boolean;
    sendExaminationTimeTable: boolean;
    examId: number;
}
export interface SendSMSMessage {
    message: string;
    examNoList: string[];
    sMSUsername: string;
    sMSPassword: string;
    sMSSenderName: string;
    examId: number;
}

export interface UploadCandidatePassportModel {
    skipErrors: boolean;
    overridePreviousValues: boolean;
    imagePrefix: string;
    imageSuffix: string;
    specialCharacters: string;
    imageFile: File;
}
export interface MarkingQuestionModel {
    question: string;
    esqId: number;
    questionNo: number;
    correct: boolean;
    mark: number;
    maxWordCount: number;
    essayMarkEarned: number;
    candidateAnswer: string;
    answerStatus: string;
    answerStatusString: string;
    answerStatusValue: string;
    possibleAnswers: string;
    hasEssaySubQuestions: boolean;
    scheduleEssaySubQuestions?: IScheduleEssaySubQuestion[];
}

export interface EssayCandidateModel {
    examNo: string;
    candidateName: string;
    examinationName: string;
    examinationScheduleID: number;
    attempt: number;
    marked: boolean;
    reviewed: boolean;
    examiner: string;
    reviewer: string;
}

export interface EssayCandidateResponseModel {
    essayCandidates: EssayCandidateModel[];
    candidateCount: number;
}

export interface SaqCandidateQuestionModel {
    examNo: string;
    candidateName: string;
    examStatus: string;
    examiner: string;
    reviewer: string;
    marked: boolean;
    reviewed: boolean;
    examinationScheduleID: number;
    attempt: number;
    candidateCount: number;
    essayQuestionModels: MarkingQuestionModel[];
}

export interface AdjustQuestionScoreModel {
    adjustmentReason: string;
    esqId: number;
    adjustedScore: number;
    scheduleEssaySubQuestions?: IScheduleEssaySubQuestion[];
}

export interface IExamInstruction {
    examinationID: number;
    instructions: string;
}
export interface IComplaintCategory {
    categoryID: string;
    categoryText: string;
    helpText: string;
}
export interface IComplaintCategoryMapping {
    categoryID: string;
    examStatus: string;
    id: number;
}
export interface IQuestionCategory {
    category: string;
    description: string;
    id: number;
}
export interface IExaminationSchedule {
    id: number;
    examNo: string;
    examinationID: number;
    startDateTime: Date;
    actualStartDateTime: Date;
    addedMinutes: number;
    totalAddedTimeInSeconds: number;
    examPaused: boolean;
    endDateTime: Date;
    actualEndDateTime: Date;
    status: string;
    score: number;
    percentageScore: number;
    focusLossCount: number;
    examStartCount: number;
    canTakeExam: boolean;
    sEBConfigKey: string;
    sEBConfigKeyVersion: number;
    interviewProctorRequestID: number;
    //viewedQuestions: boolean;
    extraField1: string;
    extraField2: string;
    extraField3: string;
    extraField4: string;
    attempt: number;
    timeTaken: string | null;
    lastInteraction: string;
    networkAvailabilityScore: number;
    overrideAIPreventExamStart: boolean;
    overrideRequireSecondView: boolean;
    recordingProcessStatus: string;
    recordingDeleted: boolean;
    randomGuid: string;
    restartReason: string;
    retakeCount: number;
    examiner: string;
    lastCheckedForImport: Date;
    lastUpdateId: string;
    disableSEB: boolean;
    allowExternalWebcam:boolean;

}

export interface IExaminationExaminer {
    examinationID: number;
    user: string;
    id: number;
}

export interface IScheduleQuestionSectionScore {
    label: string;
    score: number;
    order: number;
}

export interface IScheduleEssaySubQuestion {
    essaySubQuestionId: number;
    questionHtml: string;
    questionNoLabel: string;
    essayMarkEarned: number;
    candidateAnswer: string;
    marks: number;
}

export interface IExaminationGroup {
    examinationGroupID: string;
    name: string;
    id: number;
    noOfExam: number;
}
export interface IQuestionGroup {
    questionGroupID: string;
    name: string;
    id: number;
    examinationID: number;
    noOfQuestions: number;
}
export interface IQuestionBankGroup {
    questionGroupID: string;
    name: string;
    id: number;
    questionBankID: number;
    noOfQuestions: number;
}
export interface ICompanyExtendedInfo {
    company: string;
    logoURL: string;
    instructionsHTML: string;
}

export class MultiOpreationModel {
    examinationID: number = 0;
    examinationScheduleID: number = 0;
    examIds: number[] = [];
    scheduleIds: number[] = [];
    selectAllSch: boolean;
    reImport: boolean;
    selectAllExam: boolean;
}

export interface IQuestionBankQuestion {
    id: number;
    questionBankQuestionID: number;
    questionType: string;
    language: string;
    languageEnum: string;
    questionHtml: string;
    category: string;
    marks: number;
    maxWordCount: number;
    penaltyMarks: number;
    disabled: boolean;
    options: IQuestionOptions[];
    saqPossibleAnswers: string;
    saqAnswersList?: ICheckboxItem[];
    essaySubQuestions: IQuestionEssaySubQuestion[];
    questionBankID: number;
}

export interface IQuestionEssaySubQuestion {
    questionBankQuestionID: number;
    questionEssaySubQuestionID: number;
    questionHtml: string;
    questionNoLabel: string;
    marks: number;
}

export interface IQuestionOptions {
    questionBankQuestionID: number;
    ID: number;
    optionHtml: string;
    answer: boolean;
}

export interface IQuestionBank {
    id: number;
    questionBankID: number;
    name: string;
    description: string;
    questionType: string;
    noOfQuestions: number;
    disabled: boolean;
    isPsychometricTestBank: boolean;
    questionsJson: string;
}

export enum UploadContext {
  Exam = 'exam',
  QuestionBank = 'questionbank'
}

export interface ChangeExamScheduleStartDateTimeModel {
    ids: number[];
    dateOnly: boolean;
    startDateTime: string;
    endDateTime: string;
    restartExam: boolean;
    viaEmail: boolean;
    emailMessage: string;
    emailSubject: string;
}
